import React from 'react'

import useRecorderProvider from './useRecorderStateProvider'
import RecorderProviderView from './RecorderStateProviderView'

export default (props: any) => {
  const state = useRecorderProvider()
  return <RecorderProviderView {...state} {...props} />
}
